'use strict';

module.exports = {
	separator: ':',
	twoDigits: true
};


//////////////////
// WEBPACK FOOTER
// ./~/react-time-picker/lib/getFormat/defaults.js
// module id = 577
// module chunks = 0